import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons/faInfoCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@linaria/react';
import { ProjectRaw, ProjectURLType } from 'db/custom/schema/projects';
import Image from 'next/image';
import { UnsafeMarkdown } from '../../../components/Markdown';
import { Tooltip } from '../../../components/tooltip/Tooltip';
import { UnreachableError } from '../../../utils/UnreachableError';
import { faMapLocationDot } from '@fortawesome/free-solid-svg-icons/faMapLocationDot';
import { ShinyBorderCard } from '../../../components/ShinyBorderCard';
import { ProjectCardMagneticEffect } from './ProjectCardMagneticEffect';
import "./ProjectCard.linaria.module.css!=!./ProjectCard?./ProjectCard.linaria.module.css?css=H4sIAAAAAAAAA+VWa6+zKBD+/v4Kk5MmbVIM3ltM9o9s9gMCVk4VPECrbfP+9w1eqrae7PXLZr0Q5+IAM8/M4NZ3ccd5/qil5oZLgRQrseFXlmayBbrAVDYIOmHdOnHdOuqU4S3cO8PjBrsUNCw7cwOMwmKwgcvSyrTDsGbpt4KfP9yaNZKH/JFJRZkCClN+0chTrErllam8lA0qOKVMdNqeL87m6/zIMDmflLwIij48bG8rxh4+nEX2+aBc1yW+oXFpmWzTV15eshmz0h1jrtgpnHDdr6Yzz75MFQf/ovlRG5f8JAA3rNKIMGGYSmfGe/FTMBhbcv/AQo3J+c3Agjkof1604fkNECkME2YUf8Oex8GHfhgkaR9JJKRgk/dqTCkXJwTdJFKscjrmSsyJLKVCH4SQNJfCAM3vDEH3aGVPnLHWAMqIVLjDVDfTKnOBzFyqamBX8v7O06+sF3KWDp6b1K3Tj/b9yDMah9j3v8+FSDvkknECMnbnTG2hGxxt/sDEjr5vx2O823cO6PVtigAugLyY9xT6h/Z+PsHs/IJyrrQBpOAlfTScmgJ5ro1SWjB+KsxIVViduEAAun5HTzZQYXN1P9G5JBc9ozGxFWWRtUEYZlkwBLwpuFkLlya4ZFvP9XavQVtI9LpglTmvanXr2NcLpxiGOH2vhHfABWUt8mwVIE3Ripg9RkhXXGzDa7N3ejftrI45U3bTyWPC8ODDjtH0bo0hHPGed9fgYWBkjeBIZNIYWSHoDj4fTP9KscFASMArfGK/zWYKrF6XDov6sDTnTwHtpvOn5Ct0ufWSaO8cIzdOouk5bvZOHLiJH4VH6B1jmBxCP9p0GyZeoCsfmsewIQwxIzAtuWDgiaL4ZRFjXa2969e1uSUj+CDcPKFnv2X2yYgBOTeIWKC9dybPX2lNXrTrratrey1WjMczJ4xu3rjRWyn//5b3dxgtAfsK5zneOxzaBjBA9z35A/hXIjkG8qVgLaYMRkAdYdvcb9OhBmdalhfDUgv2Dneqx5f9fKY37H++YX46LKtVnrMYQnoY9z+cOaa2ZnfrQDeO3htb8Ez8oZslq6Vg4Qrrha4qwe6ihynamJypkjXIeWmYQlm3EcG03h7gZudobC4KG7b1Iktm5UVtvbrdpX/7x5WeNrlmOs09W83Kse9P6f9H0q6H9NACf/wOzaY/JkALAAA="
const _exp = /*#__PURE__*/() => ShinyBorderCard;
const ProjectCardContainerWrapper = /*#__PURE__*/styled(_exp())({
  name: "ProjectCardContainerWrapper",
  class: "pznzaff",
  propsAsIs: true
});
const projectCardContainerBothClassName = "pewoi4i";
const projectCardContainerInnerClassName = "p12nktqk";
const Actions = /*#__PURE__*/styled('div')({
  name: "Actions",
  class: "a1a8knbj",
  propsAsIs: false
});
const ActionButton = /*#__PURE__*/styled('a')({
  name: "ActionButton",
  class: "a1eqtm63",
  propsAsIs: false
});
const Content = /*#__PURE__*/styled('div')({
  name: "Content",
  class: "cwhxn6e",
  propsAsIs: false
});
const Title = /*#__PURE__*/styled('h3')({
  name: "Title",
  class: "tkdeys7",
  propsAsIs: false
});
const _exp3 = /*#__PURE__*/() => UnsafeMarkdown;
const CardMarkdown = /*#__PURE__*/styled(_exp3())({
  name: "CardMarkdown",
  class: "c13sm20t",
  propsAsIs: true
});
const _exp4 = /*#__PURE__*/() => Image;
const ProjectCardImage = /*#__PURE__*/styled(_exp4())({
  name: "ProjectCardImage",
  class: "p1vqvwy7",
  propsAsIs: true
});
const ProjectCardYouAreHere = /*#__PURE__*/styled('div')({
  name: "ProjectCardYouAreHere",
  class: "p1rvxvh",
  propsAsIs: false
});
const ProjectCardNonRepresentativePositioner = /*#__PURE__*/styled('div')({
  name: "ProjectCardNonRepresentativePositioner",
  class: "p190xwzy",
  propsAsIs: false
});
const ProjectCardNonRepresentativeBadgeContainer = /*#__PURE__*/styled('mark')({
  name: "ProjectCardNonRepresentativeBadgeContainer",
  class: "p1yaig8e",
  propsAsIs: false
});
interface ProjectCardProps {
  readonly project: ProjectRaw;
}
function ProjectCardNonRepresentativeBadge() {
  return <ProjectCardNonRepresentativePositioner>
		<Tooltip role='tooltip' tooltipContents={<>
			<p>
				This project&rsquo;s codebase is not representative of my current abilities or typical code quality.
				It may contain verbose, bug-prone, difficult-to-maintain, or outdated code, and generally
				does not reflect my current standards for code quality.
			</p>
			<p>
				Nevertheless, this project demonstrates strong programming capabilities and a problem-solving
				attitude, and is a good example of my past work&mdash;even if it isn&rsquo;t quite up to snuff.
			</p>
		</>}>
			<ProjectCardNonRepresentativeBadgeContainer>
				<FontAwesomeIcon icon={faInfoCircle} />
				Non-representative Code Quality
			</ProjectCardNonRepresentativeBadgeContainer>
		</Tooltip>
	</ProjectCardNonRepresentativePositioner>;
}
export function ProjectCard({
  project
}: ProjectCardProps) {
  return <ProjectCardMagneticEffect>
		<ProjectCardContainerWrapper appliedToBothClassName={projectCardContainerBothClassName} innerClassName={projectCardContainerInnerClassName}>
			{project.isCodebaseRepresentative === "false" ? <ProjectCardNonRepresentativeBadge /> : null}

			{!project.image ? null : project.image.endsWith('magic-string-current-website-iframe.png') ? <ProjectCardYouAreHere>
					<FontAwesomeIcon icon={faMapLocationDot} style={{
          marginRight: "0.5rem"
        }} />
					You Are Here!
				</ProjectCardYouAreHere> : <ProjectCardImage src={project.image} alt={project.title} width={400} height={250} />}

			<Content>

				<Title data-no-image={project.image ? null : ''}>{project.title}</Title>

				<Actions>
					{!project.githubUrl ? null : <ActionButton data-no-link-style href={project.githubUrl} target="_blank" rel="noopener noreferrer">
						<FontAwesomeIcon icon={faGithub} />
						Source Code
					</ActionButton>}
					{!project.projectUrl ? null : <ActionButton data-no-link-style href={project.projectUrl} target="_blank" rel="noopener noreferrer">
							<FontAwesomeIcon icon={faExternalLinkAlt} />
							{((): string => {
              const projectUrlType = project.projectUrlType as ProjectURLType;
              switch (projectUrlType) {
                case ProjectURLType.LiveWebDeployment:
                  return "Live Deployment";
                case ProjectURLType.NPM:
                  return "NPM page";
                case ProjectURLType.NexusMods:
                  return "Nexus Mods page";
                case ProjectURLType.CodePen:
                  return "Open on CodePen";
                default:
                  throw new UnreachableError(projectUrlType, "Unknown project URL type while rendering project card!");
              }
            })()}
						</ActionButton>}
				</Actions>

				<CardMarkdown md={project.descriptionMD} />

				{!project.challengesAndTakeawaysMD ? null : <>
					<br />
					<hr />
					<br />
					<h4>Challenges and Takeaways</h4>
					<CardMarkdown md={project.challengesAndTakeawaysMD} />
				</>}

			</Content>
		</ProjectCardContainerWrapper>
	</ProjectCardMagneticEffect>;
}